import _ from 'lodash';

export function flattenObjectRecursive(obj, separator = '.') {
    const higherKeys = _.keys(obj);
    _.forEach(higherKeys, (higherKey) => {
        const value = obj[higherKey];
        // If a value is an object, move the values of this object to the head of the object.
        if (_.isObject(value)) {
            const lowerKeys = _.keys(value);
            _.forEach(lowerKeys, (lowerKey) => {
                obj[_.join([`${higherKey}`, `${lowerKey}`], separator)] = value[lowerKey];
            });
            delete obj[higherKey];
        }
    });
    // Return if all values of object are not objects.
    if (_.every(_.values(obj), (e) => !_.isObject(e))) {
        return obj;
    }

    return flattenObjectRecursive(obj, separator);
}
